import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let choice = null;
    try {
      choice = localStorage.getItem("mbc84-cookie-consent");
    } catch (e) {
      /* ignore */
    }
    if (!choice) setVisible(true);
  }, []);

  const choose = (value) => {
    try {
      localStorage.setItem("mbc84-cookie-consent", value);
    } catch (e) {
      /* ignore */
    }
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.aside
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="glass fixed bottom-4 left-4 right-4 z-[60] rounded-2xl border border-gold/30 p-5 shadow-[0_20px_60px_rgba(0,0,0,0.6)] sm:left-auto sm:right-4 sm:max-w-sm"
          data-testid="cookie-banner"
          role="region"
          aria-label="Consentement cookies"
        >
          <div className="flex items-center gap-2.5">
            <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-gold/30 bg-gold/10 text-gold">
              <Cookie className="h-4 w-4" />
            </span>
            <h2 className="font-heading text-sm font-bold uppercase tracking-wide text-foreground">Respect de votre vie privée</h2>
          </div>
          <p className="mt-3 text-xs leading-relaxed text-muted-foreground">
            Ce site utilise uniquement un stockage technique indispensable (préférence de thème clair/sombre). Aucun
            cookie publicitaire. Un outil de mesure d'audience pourra être ajouté ultérieurement — il ne sera activé
            qu'après votre accord.
          </p>
          <div className="mt-4 flex flex-col gap-2 sm:flex-row">
            <button
              type="button"
              onClick={() => choose("all")}
              data-testid="cookie-accept-button"
              className="btn-sheen flex-1 rounded-full bg-gradient-to-r from-gold-deep via-gold to-gold-hover px-4 py-2.5 text-[11px] font-bold uppercase tracking-[0.12em] text-night transition-transform duration-300 hover:scale-[1.03]"
            >
              Tout accepter
            </button>
            <button
              type="button"
              onClick={() => choose("essential")}
              data-testid="cookie-refuse-button"
              className="flex-1 rounded-full border border-border px-4 py-2.5 text-[11px] font-bold uppercase tracking-[0.12em] text-muted-foreground transition-colors duration-300 hover:border-gold/50 hover:text-gold"
            >
              Essentiels uniquement
            </button>
          </div>
          <Link to="/cookies" data-testid="cookie-more-link" className="mt-3 inline-block text-[11px] text-gold underline underline-offset-2">
            Gestion des cookies
          </Link>
        </motion.aside>
      )}
    </AnimatePresence>
  );
}
